import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['trigger', 'filters', 'box']
  static outlets = ['autocomplete']
  static classes = ['active']

  connect() {
    // this.triggerTargets.forEach(el => this._toggleActiveClass(el))
  }

  triggerTargetConnected(target) {
    this._toggleActiveClass(target)
  }

  autocompleteOutletConnected(outlet, _element) {
    this.triggerTargets.forEach((el) => {
      outlet.setFilterValue(el.dataset.filterName, el.dataset.value)
    })
  }

  toggle({ target }) {
    target.dataset.value = !this.mapping[target.dataset.value]
    this._toggleActiveClass(target)

    if (this.hasAutocompleteOutlet) {
      this.autocompleteOutlet.applyFilter(target.dataset.filterName, target.dataset.value)
    }
  }

  _toggleActiveClass(element) {
    if (this.mapping[element.dataset.value]) {
      element.classList.add(this.activeClass)
    } else {
      element.classList.remove(this.activeClass)
    }
  }

  toggleFilters() {
    if (this.hasFiltersTarget) {
      this.filtersTarget.classList.toggle('hidden')
      if (!this.filtersTarget.classList.contains('hidden')) {
        if (this.hasBoxTarget) {
          this.boxTarget.scrollTo({ top: 0, behavior: 'smooth' });
        }
        if (this.hasAutocompleteOutlet) { this.autocompleteOutlet._expandBox() }
      }
    }
  }

  get mapping() {
    return {
      true: true,
      false: false
    }
  }
}
